
namespace RioERP.Reports {
    export class OrderOutstandingReportColumns {
        static columnsKey = 'Reports.OrderOutstandingReport';
    }
}